import React from 'react';
import styles from './Simple.module.css';

// Small, local vector placeholders. All artwork is decorative and contains no text/data.
// Replace these components or the asset URL in simple.css when approved art arrives.
export function AlienArt({ className = '' }) {
  return (
    <svg className={className} viewBox="0 0 120 120" fill="none" aria-hidden="true" focusable="false">
      <path d="M60 10C24 10 12 31 19 57c5 22 27 49 41 53 14-4 36-31 41-53 7-26-5-47-41-47Z" fill="#BBF874" />
      <path d="M31 46c20-1 25 10 23 26-17 1-26-10-23-26Zm58 0C69 45 64 56 66 72c17 1 26-10 23-26Z" fill="#111B46" />
      <path d="M50 86c7 5 13 5 20 0" stroke="#111B46" strokeWidth="4" strokeLinecap="round" />
      <circle cx="37" cy="51" r="3" fill="#E9FFFF" /><circle cx="77" cy="51" r="3" fill="#E9FFFF" />
    </svg>
  );
}

export function PlanetArt({ className = '' }) {
  return (
    <svg className={className} viewBox="0 0 120 120" fill="none" aria-hidden="true" focusable="false">
      <circle cx="60" cy="60" r="32" fill="#A88AFF" />
      <path d="M37 39c12 0 28 7 40 19M29 56c17-1 35 7 56 22" stroke="#D9C9FF" strokeWidth="7" strokeLinecap="round" />
      <ellipse cx="60" cy="63" rx="55" ry="14" transform="rotate(-25 60 63)" stroke="#62DBFF" strokeWidth="7" />
      <circle cx="98" cy="20" r="4" fill="#FF87D4" />
    </svg>
  );
}

export function RocketArt({ className = '' }) {
  return (
    <svg className={className} viewBox="0 0 120 120" fill="none" aria-hidden="true" focusable="false">
      <path d="m35 75-15 27 28-15" fill="#BBF874" />
      <path d="m49 45-25 9-3 24 30-6m25-2-8 28-24 3 4-31" fill="#A88AFF" />
      <path d="M39 66c7-28 30-47 64-49 0 35-20 56-48 66L39 66Z" fill="#72DFFF" />
      <path d="m77 23 19 20c4-8 6-17 7-26-10 0-18 3-26 6Z" fill="#FF87D4" />
      <circle cx="71" cy="49" r="10" fill="#172655" stroke="#E8FDFF" strokeWidth="4" />
    </svg>
  );
}

export function UfoArt({ className = '' }) {
  return (
    <svg className={className} viewBox="0 0 360 250" fill="none" aria-hidden="true" focusable="false">
      <path d="m135 110-60 119h210l-60-119" fill="#62DBFF" fillOpacity=".07" />
      <ellipse cx="180" cy="225" rx="111" ry="17" fill="#62DBFF" fillOpacity=".08" stroke="#62DBFF" strokeOpacity=".45" strokeWidth="2" />
      <ellipse cx="180" cy="225" rx="75" ry="9" stroke="#BBF874" strokeOpacity=".6" strokeWidth="2" />
      <path d="M123 94c0-72 114-72 114 0" fill="#61DCFF" stroke="#D5F9FF" strokeWidth="3" />
      <path d="M154 89c-7-29 59-29 52 0" fill="#BBF874" />
      <path d="m167 79 8 4m18-4-8 4" stroke="#14204B" strokeWidth="5" strokeLinecap="round" />
      <ellipse cx="180" cy="103" rx="112" ry="28" fill="#A88AFF" stroke="#D9C9FF" strokeWidth="3" />
      <path d="M68 103c28 32 197 32 224 0" fill="#6552BB" />
      <ellipse cx="180" cy="103" rx="72" ry="12" fill="#182658" stroke="#62DBFF" strokeWidth="2" />
      {[100, 140, 180, 220, 260].map((x) => <circle key={x} cx={x} cy={x === 100 || x === 260 ? 109 : 118} r="4" fill="#BBF874" />)}
      <path d="m41 51 3 9 9 3-9 3-3 9-3-9-9-3 9-3 3-9Zm270 88 3 9 9 3-9 3-3 9-3-9-9-3 9-3 3-9Z" fill="#FF87D4" />
    </svg>
  );
}

export default function SpaceScene() {
  return (
    <div className={styles.scene} aria-hidden="true">
      <PlanetArt className={styles.planet} />
      <div className={styles.orbit} />
      <UfoArt className={styles.ufo} />
      <RocketArt className={styles.rocket} />
      <span className={styles.star}>✦</span>
      <span className={styles.littleStar}>✧</span>
    </div>
  );
}
